export const inspectionAssesmentSignatureLines = ['Fagansvarlig', 'Sagsarbejder', 'Medarbejder'];
